import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import UseVideoPlayer from "./UseVideoPlayer";
import arrowright from "../assets/images/play.png";
import icons8pause from "../assets/images/icons8-pause-30.png";
import mutepic from "../assets/images/mute-512.webp";
import unmute from "../assets/images/unmute.png";
import "../assets/css/video.css";

function LogsVideo() {
  const video = JSON.parse(localStorage.getItem("url"));
  // console.log("video---", video.video1);

  const navigate = useNavigate();

  const videoElement = useRef(null);
  const {
    playerState,
    togglePlay,
    handleOnTimeUpdate,
    handleVideoProgress,
    handleVideoSpeed,
    toggleMute,
  } = UseVideoPlayer(videoElement);

  return (
    <>
      <svg
        onClick={() => navigate(-2)}
        style={{
          color: "white",
          position: "absolute",
          width: 20,
          height: 15,
          marginLeft: 20,
          marginTop: 20,
          zIndex: 1,
        }}
        viewBox="4 4 33.583 27.008"
      >
        <path
          id="Path_83491"
          d="M 37.58322906494141 15.81591987609863 L 10.46499538421631 15.81591987609863 L 19.90085029602051 6.380063056945801 L 17.50390815734863 3.999999761581421 L 3.999999761581421 17.50390815734863 L 17.50390815734863 31.0078125 L 19.88397026062012 28.62774848937988 L 10.46499538421631 19.19189453125 L 37.58322906494141 19.19189453125 L 37.58322906494141 15.81591987609863 Z"
        ></path>
      </svg>
      <div className="video-wrapper">
        <video
          style={{ objectFit: "fill", width: "100%", height: "100vh" }}
          src={video.video1}
          ref={videoElement}
          onTimeUpdate={handleOnTimeUpdate}
        />

        <div className="controls">
          <div className="actions">
            <button onClick={togglePlay}>
              {!playerState.isPlaying ? (
                <img
                  src={arrowright}
                  style={{ width: 25, height: 25 }}
                  alt=""
                />
              ) : (
                <img
                  src={icons8pause}
                  style={{ width: 20, height: 20 }}
                  alt=""
                />
              )}
            </button>
          </div>
          <input
            type="range"
            min="0"
            max="100"
            value={playerState.progress}
            onChange={(e) => handleVideoProgress(e)}
          />
          <select
            className="velocity"
            value={playerState.speed}
            onChange={(e) => handleVideoSpeed(e)}
          >
            <option value="0.50">0.50x</option>
            <option value="1">1x</option>
            <option value="1.25">1.25x</option>
            <option value="2">2x</option>
          </select>
          <button className="mute-btn" onClick={toggleMute}>
            {!playerState.isMuted ? (
              <img
                src={unmute}
                style={{
                  width: 20,
                  height: 20,
                }}
                alt=""
              />
            ) : (
              <img src={mutepic} style={{ width: 20, height: 20 }} alt="" />
            )}
          </button>
        </div>
      </div>
      {/*  <div
        style={{
          width: "100%",
          height: "100vh",
        }}
      >
        <video
          width={"100%"}
          height={"100%"}
          src={video.video1}
          autoPlay
          playing={true}
          controls
        />
       
      </div> */}
    </>
  );
}

export default LogsVideo;
